// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2uUe4","col":"styles_col__1rqdi","fulfillmentStatus":"styles_fulfillmentStatus__3_yOA","emailCol":"styles_emailCol__3p8vm"};